import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tenantService } from '../../services/authentication/tenantService';
import { setTenantIdInStorage, removeTenantIdFromStorage } from '../../services/authentication/supertokens';

export const useAuthenticationChoice = () => {
  const [orgId, setOrgId] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleJoinOrg = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!orgId.trim()) {
      setError('Please enter your organization ID');
      return;
    }

    try {
      const orgExists = await tenantService.checkTenantExists(orgId);

      if (!orgExists) {
        setError('Organization does not exist');
        return;
      }

      // Clear any existing tenant ID
      removeTenantIdFromStorage();
      
      // Set the new tenant ID in storage
      setTenantIdInStorage(orgId.trim());
      
      setError('');
      // Navigate directly to the login page with the new tenant ID
      navigate(`/${orgId.trim()}/login`);
    } catch (error) {
      console.error('Error checking organization:', error);
      setError('Error checking organization. Please try again.');
    }
  };

  const handleCreateOrg = () => {
    navigate('/organization/create');
  };

  return {
    orgId,
    setOrgId,
    error,
    setError,
    handleJoinOrg,
    handleCreateOrg
  };
}; 